var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R003 - Map Orientation - Heading Up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 13.6L7.99995 11.56L3.19995 13.6L7.99995 1.95996L12.8 13.6ZM4.67995 12.12L7.99995 10.68L11.32 12.08L7.99995 3.99996L4.67995 12.12Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.adb7425d15f7e1fa5c5df4ea09afb40a.svg";
export { ForwardRef as ReactComponent };